import { mediaQueries, palette } from '@centivo/react-components'
import styled, { css } from 'styled-components'

import { ContentSection } from 'src/refactor/structure'

interface Props {
  shouldHideMap?: boolean
  isListEmpty?: boolean
  isRequestCanceled?: boolean
}

export const LoadingContainer = styled.div`
  width: 100%;
  height: 78px;
  display: flex;
  flex-direction: column;
  align-items: center;

  > span {
    margin-top: 20px;
    font-size: 1.25rem;
    font-weight: 700;
    color: ${palette.brand.orange};
    ${({ theme }) => {
      switch (theme.template) {
        case 'template-4':
          return {
            fontWeight: 500,
          }
        default:
          return {}
      }
    }}
  }
`

export const LoadingMessage = styled.div`
  margin-top: 4px;
  display: flex;
  flex-direction: row;
  gap: 8px;

  > button {
    background: transparent;
    border: none;
    font-weight: 600;
    font-size: 1rem;
    cursor: pointer;
    color: ${palette.brand.orange};

    ${({ theme }) => {
      switch (theme.template) {
        case 'template-4':
          return {
            fontWeight: 500,
          }
        default:
          return {}
      }
    }}
  }
`

export const RlListMapContainer = styled(ContentSection)<Props>`
  display: grid;
  grid-template-columns: 100%;
  grid-column-gap: 1.625rem;
  padding-bottom: 10rem !important;

  @media ${mediaQueries.desktop} {
    grid-template-columns: ${props =>
      props.isListEmpty && !props.isRequestCanceled ? '1fr' : '57.5% 1fr'};
  }

  @media ${mediaQueries.mobile} {
    padding-bottom: 0;
  }
`

export const RlListContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const RlMapContainer = styled.div`
  > div {
    border-radius: 1.25rem;
  }
  @media ${mediaQueries.desktop} {
    display: flex;
    flex-direction: column;
    grid-column: 2;
    margin: ${({ theme }) => {
      switch (theme.template) {
        case 'template-4':
          return '8.375rem 0 0'
        default:
          return '5.5rem 0 0'
      }
    }};
    width: 100%;
    height: 100%;
  }
`

export const ResultsListFooter = styled.div`
  height: 6.25rem;
  width: 100vw;
  bottom: 0;
  left: 0;

  > div {
    width: 100%;
    padding: 0 1.25rem;
    margin: auto;

    ${({ theme }) => theme.screenWidth}
  }

  position: absolute;
  padding-top: 2.5rem;
  background-color: #f7f4e6;

  > div {
    @media ${mediaQueries.desktop} {
      padding: 0 2rem;
    }
  }

  li {
    border-radius: 6px !important;
  }
`

export const RlPaginateContainer = styled.div`
  width: 100%;
  user-select: none;

  background-color: #f7f4e6;

  * {
    color: #212121;
  }

  .disabled {
    color: #bbbdbf;
  }

  li:not(.next, .previous):hover,
  .active {
    background-color: ${palette.brand.darkGreen} !important;
  }

  li.next,
  li.previous {
    &::before {
      background-color: ${palette.brand.darkGreen};
    }
  }

  ul {
    min-width: auto;
  }

  @media ${mediaQueries.desktop} {
    margin-left: 4.6rem;
    max-width: 18.75rem;
    width: min-content;
  }
`
